/**
 * Represents the name of the
 * {@link CustomFieldSelectAttributeOption.options field} of select attribute
 * options.
 *
 * @remarks
 *   The key is used in various strings that are not typed.
 */
export const optionsKey = 'options';
